module.exports = __webpack_public_path__ + "static/media/logo_co_cor.67b23850.svg";